(function($) {
  "use strict";

  var debugFlag = 1,
    $pageWrapper = $(".page-wrapper"),
    defaultDatepickerSettings = {
      showOn: "button",
      buttonImageOnly: false,
      buttonText: "Calendar View",
      dayNamesShort: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      showButtonPanel: true,
      closeText: "Close",
      altFormat: "dd/mm/yy",
      dateFormat: "dd/mm/yy",
      dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
      firstDay: 1,
      onClose: removeAria,
      onSelect: function(d, i) {
        this.focus();

        if ($(".js-filter-radiobuttons").length) {
          $('.js-filter-radiobuttons input[type="radio"]').prop(
            "checked",
            false
          );
        }

        //what'on page
        if ($("#queries_date_range_query").length) {
          setHiddenSearchDateField(d);
        }
      }
    };

  if ($(".js-reset").length) {
    $(".js-reset").click(function(e) {
      e.preventDefault();

      if ($(".js-datepicker").length) {
        $(".js-datepicker").removeClass("ui-datepicker-ready");
        $(".js-datepicker").datepicker("setDate", null);
        $(".js-datepicker")
          .find(".ui-state-active")
          .removeClass("ui-state-active");
        $(".js-datepicker").addClass("ui-datepicker-ready");
      }

      if ($(".js-reset-field").length) {
        $(".js-reset-field").each(function() {
          var $field = $(this);

          if ($field.is('input[type="text"]')) {
            $field.val("");
          } else if ($field.is('input[type="radio"]')) {
            $field.prop("checked", false).removeClass("checked");
          } else if ($field.is("select")) {
            $field.find('option[value=""]').prop("selected", "selected");
          } else {
            if ($field.find('input[type="text"]').length) {
              $field.find('input[type="text"]').val("");
            } else if ($field.find('input[type="radio"]').length) {
              $field
                .find('input[type="radio"]')
                .prop("checked", false)
                .removeClass("checked");
            } else if ($field.find("select").length) {
              $field.find('option[value=""]').prop("selected", "selected");
            }
          }
        });
      }

      sessionStorage.removeItem("startDate");
      sessionStorage.removeItem("toDate");
    });
  }

  if ($(".js-file").length) {
    $(".js-file").each(function() {
      var $input = $(this),
        $label = $input.siblings("label"),
        $info = $input.siblings("div");

      $info.attr("data-default", $info.text());

      $input.change(function(e) {
        var file = $input
          .val()
          .split("\\")
          .pop();

        if (file.length) {
          $info.text(file);
        } else {
          $info.text($info.attr("data-default"));
        }
      });
    });
  }

  if ($(".js-datepicker").length) {
    $(".js-datepicker").each(function() {
      var $datepicker = $(this);

      if ($datepicker[0].hasAttribute("data-field")) {
        var datePickerSettings = $.extend({}, defaultDatepickerSettings, {
          altField: "#" + $datepicker.attr("data-field"),
          minDate: 0
        });
        $datepicker.datepicker(datePickerSettings);
      } else {
        $datepicker.datepicker(defaultDatepickerSettings);
      }

      $datepicker.datepicker("setDate", null);
      $datepicker.find(".ui-state-active").removeClass("ui-state-active");
      $datepicker.addClass("ui-datepicker-ready");
    });

    dayTripper();
  }

  //what'on page
  function setHiddenSearchDateField(d) {
    var temp = d.split("/");
    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "Novermber",
      "December"
    ];
    var monthIndex = parseInt(temp[1]);
    var month = months[monthIndex - 1];
    $("#queries_date_range_query").val(temp[0] + month + temp[2]);
  }

  function dayTripper() {
    $(".ui-datepicker-trigger").click(function() {
      var $datepickerCalendar = $(this),
        $datepicker = $datepickerCalendar.siblings(".js-datepicker");

      setTimeout(function() {
        var today = $(".ui-datepicker-today a")[0];

        if (!today) {
          today = $(".ui-state-active")[0] || $(".ui-state-default")[0];
        }

        // Hide the entire page (except the date picker) from screen readers to prevent document navigation (by headings, etc.) while the popup is open
        $pageWrapper.attr("aria-hidden", "true");

        // Hide the 'today' button because it doesn't do what you think it supposed to do
        $(".ui-datepicker-current").hide();

        today.focus();
        datePickHandler($datepicker[0]);
        $datepicker.addClass("active");

        $(document).on(
          "click",
          "#ui-datepicker-div .ui-datepicker-close",
          function() {
            closeCalendar();
          }
        );
      }, 0);
    });
  }

  function datePickHandler(input) {
    var activeDate,
      container = document.getElementById("ui-datepicker-div");

    if (!container || !input) {
      return;
    }

    container.setAttribute("role", "application");
    container.setAttribute("aria-label", "Calendar view date-picker");

    // the top controls:
    var prev = $(".ui-datepicker-prev", container)[0],
      next = $(".ui-datepicker-next", container)[0];

    // This is the line that needs to be fixed for use on pages with base URL set in head
    next.href = "javascript:void(0)";
    prev.href = "javascript:void(0)";

    next.setAttribute("role", "button");
    next.removeAttribute("title");
    prev.setAttribute("role", "button");
    prev.removeAttribute("title");

    appendOffscreenMonthText(next);
    appendOffscreenMonthText(prev);

    // attaching individual click listeners to the prev/next month buttons each time they are added to the DOM
    $(next).on("click", handleNextClicks);
    $(prev).on("click", handlePrevClicks);

    dayMonthYearText();

    $(container).on("keydown", function calendarKeyboardListener(keyVent) {
      var which = keyVent.which,
        target = keyVent.target,
        dateCurrent = getCurrentDate(container);

      if (!dateCurrent) {
        dateCurrent = $("a.ui-state-default")[0];
        setHighlightState(dateCurrent, container);
      }

      if (27 === which) {
        keyVent.stopPropagation();
        return closeCalendar();
      } else if (which === 9 && keyVent.shiftKey) {
        // SHIFT + TAB
        keyVent.preventDefault();
        if ($(target).hasClass("ui-datepicker-close")) {
          // close button
          $(".ui-datepicker-prev")[0].focus();
        } else if ($(target).hasClass("ui-state-default")) {
          // a date link
          $(".ui-datepicker-close")[0].focus();
        } else if ($(target).hasClass("ui-datepicker-prev")) {
          // the prev link
          $(".ui-datepicker-next")[0].focus();
        } else if ($(target).hasClass("ui-datepicker-next")) {
          // the next link
          activeDate = $(".ui-state-highlight") || $(".ui-state-active")[0];
          if (activeDate) {
            activeDate.focus();
          }
        }
      } else if (which === 9) {
        // TAB
        keyVent.preventDefault();
        if ($(target).hasClass("ui-datepicker-close")) {
          // close button
          activeDate = $(".ui-state-highlight") || $(".ui-state-active")[0];
          if (activeDate) {
            activeDate.focus();
          }
        } else if ($(target).hasClass("ui-state-default")) {
          $(".ui-datepicker-next")[0].focus();
        } else if ($(target).hasClass("ui-datepicker-next")) {
          $(".ui-datepicker-prev")[0].focus();
        } else if ($(target).hasClass("ui-datepicker-prev")) {
          activeDate = $(".ui-state-highlight") || $(".ui-state-active")[0];
          if (activeDate) {
            activeDate.focus();
          }
        }
      } else if (which === 37) {
        // LEFT arrow key
        // if we're on a date link...
        if (
          !$(target).hasClass("ui-datepicker-close") &&
          $(target).hasClass("ui-state-default")
        ) {
          keyVent.preventDefault();
          previousDay(target);
        }
      } else if (which === 39) {
        // RIGHT arrow key
        // if we're on a date link...
        if (
          !$(target).hasClass("ui-datepicker-close") &&
          $(target).hasClass("ui-state-default")
        ) {
          keyVent.preventDefault();
          nextDay(target);
        }
      } else if (which === 38) {
        // UP arrow key
        if (
          !$(target).hasClass("ui-datepicker-close") &&
          $(target).hasClass("ui-state-default")
        ) {
          keyVent.preventDefault();
          upHandler(target, container, prev);
        }
      } else if (which === 40) {
        // DOWN arrow key
        if (
          !$(target).hasClass("ui-datepicker-close") &&
          $(target).hasClass("ui-state-default")
        ) {
          keyVent.preventDefault();
          downHandler(target, container, next);
        }
      } else if (which === 13) {
        // ENTER
        if ($(target).hasClass("ui-state-default")) {
          setTimeout(function() {
            closeCalendar();
          }, 100);
        } else if ($(target).hasClass("ui-datepicker-prev")) {
          handlePrevClicks();
        } else if ($(target).hasClass("ui-datepicker-next")) {
          handleNextClicks();
        }
      } else if (32 === which) {
        if (
          $(target).hasClass("ui-datepicker-prev") ||
          $(target).hasClass("ui-datepicker-next")
        ) {
          target.click();
        }
      } else if (33 === which) {
        // PAGE UP
        moveOneMonth(target, "prev");
      } else if (34 === which) {
        // PAGE DOWN
        moveOneMonth(target, "next");
      } else if (36 === which) {
        // HOME
        var firstOfMonth = $(target)
          .closest("tbody")
          .find(".ui-state-default")[0];
        if (firstOfMonth) {
          firstOfMonth.focus();
          setHighlightState(firstOfMonth, $("#ui-datepicker-div")[0]);
        }
      } else if (35 === which) {
        // END
        var $daysOfMonth = $(target)
            .closest("tbody")
            .find(".ui-state-default"),
          lastDay = $daysOfMonth[$daysOfMonth.length - 1];
        if (lastDay) {
          lastDay.focus();
          setHighlightState(lastDay, $("#ui-datepicker-div")[0]);
        }
      }
      $(".ui-datepicker-current").hide();
    });
  }

  function closeCalendar() {
    var $container = $("#ui-datepicker-div");
    $container.off("keydown");

    var $input = $(".js-datepicker.active");
    $input
      .datepicker("hide")
      .removeClass("active")
      .focus();
  }

  function removeAria() {
    // make the rest of the page accessible again:
    $pageWrapper.removeAttr("aria-hidden");
  }

  function moveOneMonth(currentDate, dir) {
    var button =
      dir === "next"
        ? $(".ui-datepicker-next")[0]
        : $(".ui-datepicker-prev")[0];

    if (!button) {
      return;
    }

    var ENABLED_SELECTOR =
      "#ui-datepicker-div tbody td:not(.ui-state-disabled)";
    var $currentCells = $(ENABLED_SELECTOR);
    var currentIdx = $.inArray(currentDate.parentNode, $currentCells);

    button.click();
    setTimeout(function() {
      updateHeaderElements();

      var $newCells = $(ENABLED_SELECTOR);
      var newTd = $newCells[currentIdx];
      var newAnchor = newTd && $(newTd).find("a")[0];

      while (!newAnchor) {
        currentIdx--;
        newTd = $newCells[currentIdx];
        newAnchor = newTd && $(newTd).find("a")[0];
      }

      setHighlightState(newAnchor, $("#ui-datepicker-div")[0]);
      newAnchor.focus();
    }, 0);
  }

  function handleNextClicks() {
    setTimeout(function() {
      updateHeaderElements();
      prepHighlightState();
      $(".ui-datepicker-next").focus();
      $(".ui-datepicker-current").hide();
    }, 0);
  }

  function handlePrevClicks() {
    setTimeout(function() {
      updateHeaderElements();
      prepHighlightState();
      $(".ui-datepicker-prev").focus();
      $(".ui-datepicker-current").hide();
    }, 0);
  }

  /* Previous */
  function previousDay(dateLink) {
    var container = document.getElementById("ui-datepicker-div");
    if (!dateLink) {
      return;
    }
    var td = $(dateLink).closest("td");
    if (!td) {
      return;
    }

    var prevTd = $(td).prev(),
      prevDateLink = $("a.ui-state-default", prevTd)[0];

    if (prevTd && prevDateLink) {
      setHighlightState(prevDateLink, container);
      prevDateLink.focus();
    } else {
      handlePrevious(dateLink);
    }
  }

  function handlePrevious(target) {
    var container = document.getElementById("ui-datepicker-div");
    if (!target) {
      return;
    }
    var currentRow = $(target).closest("tr");
    if (!currentRow) {
      return;
    }
    var previousRow = $(currentRow).prev();

    if (!previousRow || previousRow.length === 0) {
      // there is not previous row, so we go to previous month...
      previousMonth();
    } else {
      var prevRowDates = $("td a.ui-state-default", previousRow),
        prevRowDate = prevRowDates[prevRowDates.length - 1];

      if (prevRowDate) {
        setTimeout(function() {
          setHighlightState(prevRowDate, container);
          prevRowDate.focus();
        }, 0);
      }
    }
  }

  function previousMonth() {
    var prevLink = $(".ui-datepicker-prev")[0],
      container = document.getElementById("ui-datepicker-div");
    prevLink.click();
    // focus last day of new month
    setTimeout(function() {
      var trs = $("tr", container),
        lastRowTdLinks = $("td a.ui-state-default", trs[trs.length - 1]),
        lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];

      // updating the cached header elements
      updateHeaderElements();

      setHighlightState(lastDate, container);
      lastDate.focus();
    }, 0);
  }

  /* Next */
  function nextDay(dateLink) {
    var container = document.getElementById("ui-datepicker-div");
    if (!dateLink) {
      return;
    }
    var td = $(dateLink).closest("td");
    if (!td) {
      return;
    }
    var nextTd = $(td).next(),
      nextDateLink = $("a.ui-state-default", nextTd)[0];

    if (nextTd && nextDateLink) {
      setHighlightState(nextDateLink, container);
      nextDateLink.focus(); // the next day (same row)
    } else {
      handleNext(dateLink);
    }
  }

  function handleNext(target) {
    var container = document.getElementById("ui-datepicker-div");
    if (!target) {
      return;
    }
    var currentRow = $(target).closest("tr"),
      nextRow = $(currentRow).next();

    if (!nextRow || nextRow.length === 0) {
      nextMonth();
    } else {
      var nextRowFirstDate = $("a.ui-state-default", nextRow)[0];
      if (nextRowFirstDate) {
        setHighlightState(nextRowFirstDate, container);
        nextRowFirstDate.focus();
      }
    }
  }

  function nextMonth() {
    var nextMon = $(".ui-datepicker-next")[0],
      container = document.getElementById("ui-datepicker-div");
    nextMon.click();
    // focus the first day of the new month
    setTimeout(function() {
      // updating the cached header elements
      updateHeaderElements();

      var firstDate = $("a.ui-state-default", container)[0];
      setHighlightState(firstDate, container);
      firstDate.focus();
    }, 0);
  }

  /* Up */
  function upHandler(target, cont, prevLink) {
    prevLink = $(".ui-datepicker-prev")[0];
    var rowContext = $(target).closest("tr");
    if (!rowContext) {
      return;
    }
    var rowTds = $("td", rowContext),
      rowLinks = $("a.ui-state-default", rowContext),
      targetIndex = $.inArray(target, rowLinks),
      prevRow = $(rowContext).prev(),
      prevRowTds = $("td", prevRow),
      parallel = prevRowTds[targetIndex],
      linkCheck = $("a.ui-state-default", parallel)[0];

    if (prevRow && parallel && linkCheck) {
      // there is a previous row, a td at the same index
      // of the target AND theres a link in that td
      setHighlightState(linkCheck, cont);
      linkCheck.focus();
    } else {
      // we're either on the first row of a month, or we're on the
      // second and there is not a date link directly above the target
      prevLink.click();
      setTimeout(function() {
        // updating the cached header elements
        updateHeaderElements();
        var newRows = $("tr", cont),
          lastRow = newRows[newRows.length - 1],
          lastRowTds = $("td", lastRow),
          tdParallelIndex = $.inArray(target.parentNode, rowTds),
          newParallel = lastRowTds[tdParallelIndex],
          newCheck = $("a.ui-state-default", newParallel)[0];

        if (lastRow && newParallel && newCheck) {
          setHighlightState(newCheck, cont);
          newCheck.focus();
        } else {
          // theres no date link on the last week (row) of the new month
          // meaning its an empty cell, so we'll try the 2nd to last week
          var secondLastRow = newRows[newRows.length - 2],
            secondTds = $("td", secondLastRow),
            targetTd = secondTds[tdParallelIndex],
            linkCheck = $("a.ui-state-default", targetTd)[0];

          if (linkCheck) {
            setHighlightState(linkCheck, cont);
            linkCheck.focus();
          }
        }
      }, 0);
    }
  }

  /* Down */
  function downHandler(target, cont, nextLink) {
    nextLink = $(".ui-datepicker-next")[0];
    var targetRow = $(target).closest("tr");
    if (!targetRow) {
      return;
    }
    var targetCells = $("td", targetRow),
      cellIndex = $.inArray(target.parentNode, targetCells), // the td (parent of target) index
      nextRow = $(targetRow).next(),
      nextRowCells = $("td", nextRow),
      nextWeekTd = nextRowCells[cellIndex],
      nextWeekCheck = $("a.ui-state-default", nextWeekTd)[0];

    if (nextRow && nextWeekTd && nextWeekCheck) {
      // theres a next row, a TD at the same index of `target`,
      // and theres an anchor within that td
      setHighlightState(nextWeekCheck, cont);
      nextWeekCheck.focus();
    } else {
      nextLink.click();

      setTimeout(function() {
        // updating the cached header elements
        updateHeaderElements();

        var nextMonthTrs = $("tbody tr", cont),
          firstTds = $("td", nextMonthTrs[0]),
          firstParallel = firstTds[cellIndex],
          firstCheck = $("a.ui-state-default", firstParallel)[0];

        if (firstParallel && firstCheck) {
          setHighlightState(firstCheck, cont);
          firstCheck.focus();
        } else {
          // lets try the second row b/c we didnt find a
          // date link in the first row at the target's index
          var secondRow = nextMonthTrs[1],
            secondTds = $("td", secondRow),
            secondRowTd = secondTds[cellIndex],
            secondCheck = $("a.ui-state-default", secondRowTd)[0];

          if (secondRow && secondCheck) {
            setHighlightState(secondCheck, cont);
            secondCheck.focus();
          }
        }
      }, 0);
    }
  }

  function onCalendarHide() {
    closeCalendar();
  }

  // add an aria-label to the date link indicating the currently focused date (formatted identically to the required format: dd/mm/yyyy)
  function dayMonthYearText() {
    var cleanUps = $(".amaze-date");

    $(cleanUps).each(function(clean) {
      // each(cleanUps, function (clean) {
      clean.parentNode.removeChild(clean);
    });

    var datePickDiv = document.getElementById("ui-datepicker-div");
    // in case we find no datepick div
    if (!datePickDiv) {
      return;
    }

    var dates = $("a.ui-state-default", datePickDiv);
    $(dates)
      .attr("role", "button")
      .on("keydown", function(e) {
        if (e.which === 32) {
          e.preventDefault();
          e.target.click();
          setTimeout(function() {
            closeCalendar();
          }, 100);
        }
      });
    $(dates).each(function(index, date) {
      var currentRow = $(date).closest("tr"),
        currentTds = $("td", currentRow),
        currentIndex = $.inArray(date.parentNode, currentTds),
        headThs = $("thead tr th", datePickDiv),
        dayIndex = headThs[currentIndex],
        daySpan = $("span", dayIndex)[0],
        monthName = $(".ui-datepicker-month", datePickDiv)[0].innerHTML,
        year = $(".ui-datepicker-year", datePickDiv)[0].innerHTML,
        number = date.innerHTML;

      if (!daySpan || !monthName || !number || !year) {
        return;
      }

      // AT Reads: {date} {month} {year} {day}
      // '18 December 2014 Thursday'
      var dateText =
        date.innerHTML + " " + monthName + " " + year + " " + daySpan.title;
      date.setAttribute("aria-label", dateText);
    });
  }

  // update the cached header elements because we're in a new month or year
  function updateHeaderElements() {
    var context = document.getElementById("ui-datepicker-div");
    if (!context) {
      return;
    }

    var prev = $(".ui-datepicker-prev", context)[0],
      next = $(".ui-datepicker-next", context)[0];

    //make them click/focus - able
    next.href = "javascript:void(0)";
    prev.href = "javascript:void(0)";

    next.setAttribute("role", "button");
    prev.setAttribute("role", "button");
    appendOffscreenMonthText(next);
    appendOffscreenMonthText(prev);

    $(next).on("click", handleNextClicks);
    $(prev).on("click", handlePrevClicks);

    // add month day year text
    dayMonthYearText();
  }

  function prepHighlightState() {
    var highlight,
      cage = document.getElementById("ui-datepicker-div");
    highlight =
      $(".ui-state-highlight", cage)[0] || $(".ui-state-default", cage)[0];
    if (highlight && cage) {
      setHighlightState(highlight, cage);
    }
  }

  // Set the highlighted class to date elements, when focus is recieved
  function setHighlightState(newHighlight, container) {
    var prevHighlight = getCurrentDate(container);
    // remove the highlight state from previously highlighted date and add it to our newly active date
    $(prevHighlight).removeClass("ui-state-highlight");
    $(newHighlight).addClass("ui-state-highlight");
  }

  // grabs the current date based on the hightlight class
  function getCurrentDate(container) {
    var currentDate = $(".ui-state-highlight", container)[0];
    return currentDate;
  }

  //Appends logical next/prev month text to the buttons
  function appendOffscreenMonthText(button) {
    var buttonText,
      isNext = $(button).hasClass("ui-datepicker-next"),
      months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
      ];

    var currentMonth = $(".ui-datepicker-title .ui-datepicker-month")
        .text()
        .toLowerCase(),
      monthIndex = $.inArray(currentMonth.toLowerCase(), months),
      currentYear = $(".ui-datepicker-title .ui-datepicker-year")
        .text()
        .toLowerCase(),
      adjacentIndex = isNext ? monthIndex + 1 : monthIndex - 1;

    if (isNext && currentMonth === "december") {
      currentYear = parseInt(currentYear, 10) + 1;
      adjacentIndex = 0;
    } else if (!isNext && currentMonth === "january") {
      currentYear = parseInt(currentYear, 10) - 1;
      adjacentIndex = months.length - 1;
    }

    buttonText = isNext
      ? "Next Month, " + firstToCap(months[adjacentIndex]) + " " + currentYear
      : "Previous Month, " +
        firstToCap(months[adjacentIndex]) +
        " " +
        currentYear;

    $(button)
      .find(".ui-icon")
      .html(buttonText);
  }

  // Returns the string with the first letter capitalized
  function firstToCap(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* Utility functions */
  function isOdd(num) {
    return num % 2;
  }

  function uncheck() {
    $("#page_asset_builder_100855").change(function() {
      $("input:checkbox").prop("checked", $(this).prop("checked"));
    });
  }

  function fillStartEndDate() {
    var startDateTime = {
      date: $("#form-start-date")
        .val()
        .split("/"),
      hh: $("#form-start-hours").val(),
      mm: $("#form-start-minutes").val(),
      meridian: $("#form-start-am-pm").val()
    };
    var endDateTime = {
      date: $("#form-end-date")
        .val()
        .split("/"),
      hh: $("#form-end-hours").val(),
      mm: $("#form-end-minutes").val(),
      meridian: $("#form-end-am-pm").val()
    };

    /*enabling field that are going to be used*/
    $("#calendar_event_single_0_end_day").removeAttr("disabled");
    $("#calendar_event_single_0_end_month").removeAttr("disabled");
    $("#calendar_event_single_0_end_year").removeAttr("disabled");

    $("#calendar_event_single_0_start_hours").removeAttr("disabled");
    $("#calendar_event_single_0_start_minutes").removeAttr("disabled");
    $("#calendar_event_single_0_start_is_pm").removeAttr("disabled");

    $("#calendar_event_single_0_end_hours").removeAttr("disabled");
    $("#calendar_event_single_0_end_minutes").removeAttr("disabled");
    $("#calendar_event_single_0_end_is_pm").removeAttr("disabled");
    $("#calendar_event_single_0_start_time_enabled").prop("checked", true);
    $("#calendar_event_single_0_end_enabled").prop("checked", true);
    $("#calendar_event_single_0_end_date_enabled").removeAttr("disabled");
    $("#calendar_event_single_0_end_date_enabled").prop("checked", true);
    $("#calendar_event_single_0_end_time_enabled").removeAttr("disabled");
    $("#calendar_event_single_0_end_time_enabled").prop("checked", true);
    /*end enabling field that are going to be used*/

    $("#calendar_event_single_0_start_day").val(startDateTime.date[0]);
    $("#calendar_event_single_0_start_month").val(
      startDateTime.date[1].replace(/^0+/, "")
    ).change;
    $("#calendar_event_single_0_start_year").val(startDateTime.date[2]);

    $("#calendar_event_single_0_end_day").val(endDateTime.date[0]);
    $("#calendar_event_single_0_end_month").val(
      endDateTime.date[1].replace(/^0+/, "")
    ).change;
    $("#calendar_event_single_0_end_year").val(endDateTime.date[2]);

    $("#calendar_event_single_0_start_hours").val(startDateTime.hh);
    $("#calendar_event_single_0_start_minutes").val(startDateTime.mm);
    $("#calendar_event_single_0_start_is_pm")
      .val(startDateTime.meridian)
      .change();
    $("#calendar_event_single_0_end_hours").val(endDateTime.hh);
    $("#calendar_event_single_0_end_minutes").val(endDateTime.mm);
    $("#calendar_event_single_0_end_is_pm")
      .val(endDateTime.meridian)
      .change();
  }

  function uploadImage(form) {
    var jsAPI = new Squiz_Matrix_API({ key: "6877075355" });

    uncheck();
    var imageData = new FormData();
    var Image = $(".js-file")[0].files[0];

    imageData.append("AB_100490_ASSET_BUILDER_ACTION", "create");
    imageData.append("AB_100490_ASSET_BUILDER_CREATE_TYPE", "image");
    imageData.append("asset_action", "create");
    imageData.append("asset_ei_screen", "details");
    imageData.append("sq_link_path", "");
    imageData.append("sq_preview_url", "");
    imageData.append("image_0_926", Image.name);
    imageData.append("image_0", Image);
    imageData.append("image_0_server_file", "");
    imageData.append("sq_lock_release", "0");
    imageData.append("sq_commit_button", "Commit");

    $.ajax({
      method: "POST",
      url: "/create-event/upload-event-images",
      data: imageData,
      contentType: false,
      processData: false
    })
      .done(function(resp) {
        if (debugFlag) {
          console.log("Image upload is done");
          console.log(resp);
        }

        if (resp.success) {
          if (debugFlag) {
            console.log("Image upload is successfull");
            console.log(["data", resp]);
          }

          var imageMatrixId = resp.fileId,
            imageMatrixUrl = resp.url;
          var newPath = imageMatrixId + "-" + $(".js-file")[0].files[0].name;

          jsAPI.setWebPath({
            asset_id: imageMatrixId,
            paths: [newPath]
          });

          $(
            "#metadata_field_related_asset_100079_value\\[0\\]\\[assetid\\]"
          ).val(imageMatrixId);
          //this will set the value for the description
          $("#calendar_event_single_0_3163_contents_div_viper_input").html(
            $("#metadata_field_text_99247_value").val()
          );
          if (debugFlag) {
            console.log("Form Submit");
          }
          form.submit();
        } else {
          if (debugFlag) {
            console.log("Image upload is not successfull");
            console.log(["data", resp]);
          }
          displayFormError();
        }
      })
      .fail(function(error) {
        if (debugFlag) {
          console.log("Image upload is failed");
          console.log(error);
        }
        displayFormError();
      })
      .always(function() {
        if (debugFlag) {
          console.log("AJAX Image upload");
        }
      });
  }

  /* Display genetal form error */
  function displayFormError() {
    if ($(".js-form-loader").length) {
      $(".js-form-loader").fadeOut(300);
    }

    $(".js-submit").prop("disabled", false);

    if ($(".js-form-technical-error").length) {
      $(".js-form-technical-error").show();

      $("html, body").animate(
        {
          scrollTop: 0
        },
        300
      );
    }
  }

  $(document).ready(function() {
    $.validator.addMethod("startEndDate", function(value, element) {
      var $startDate = $(element)
          .closest("form")
          .find('input[name="start-date"]'),
        startDate = $startDate.datepicker("getDate"),
        $endDate = $startDate.closest("form").find('input[name="end-date"]'),
        endDate = $endDate.datepicker("getDate");

      if (startDate && endDate) {
        if (endDate >= startDate) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });

    $.validator.addMethod(
      "filesize",
      function(value, element, param) {
        return this.optional(element) || element.files[0].size <= param;
      },
      "File size must be less than {0}"
    );

    $.validator.addMethod("startEndTime", function(value, element) {
      var $form = $(element).closest("form"),
        $startDate = $(element)
          .closest("form")
          .find('input[name="start-date"]'),
        startDate = $startDate.datepicker("getDate"),
        $endDate = $(element)
          .closest("form")
          .find('input[name="end-date"]'),
        endDate = $endDate.datepicker("getDate"),
        startHours = parseInt($form.find('select[name="start-hours"]').val()),
        startMinutes = parseInt(
          $form.find('select[name="start-minutes"]').val()
        ),
        startAmPm = parseInt($form.find('select[name="start-am-pm"]').val()),
        startTime = startHours * 60 + startMinutes + startAmPm * 12 * 60 * 1000,
        endHours = parseInt($form.find('select[name="end-hours"]').val()),
        endMinutes = parseInt($form.find('select[name="end-minutes"]').val()),
        endAmPm = parseInt($form.find('select[name="end-am-pm"]').val()),
        endTime = endHours * 60 + endMinutes + endAmPm * 12 * 60 * 1000;

      var _startDate = parseInt(moment(startDate).unix());
      var _endDate = parseInt(moment(endDate).unix());
      var start = _startDate + startTime;
      var end = _endDate + endTime;
      console.log("start= " + startTime);
      if (
        !isNaN(startHours) &&
        !isNaN(startMinutes) &&
        !isNaN(endHours) &&
        !isNaN(endMinutes)
      ) {
        //applied fixed for support-66769
        if (
          startAmPm == 1 &&
          startTime >= 720720 &&
          endAmPm == 1 &&
          endTime < 720720
        ) {
          return true;
        } else if (
          startAmPm == 0 &&
          startTime >= 720 &&
          endAmPm == 0 &&
          endTime < 720
        ) {
          return true;
        } else if (end > start) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });

    $.validator.addMethod("timeRequired", function(value, element) {
      var $element = $(element),
        $fields = $element.closest(".form__field-time").find("select"),
        flag = true;

      $fields.each(function() {
        if ($(this).val() == "") {
          flag = false;
        }
      });

      return flag;
    });

    if ($("#page_asset_builder_100855").length) {
      $("#page_asset_builder_100855").validate({
        rules: {
          calendar_event_single_0_3162: {
            required: true
          },
          "start-date": {
            required: true
          },
          "end-date": {
            required: true,
            startEndDate: "#form-end-date"
          },
          "start-hours": {
            timeRequired: true
          },
          "end-hours": {
            timeRequired: true,
            startEndTime: true
          },
          metadata_field_text_99250_value: {
            required: true
          },
          image: {
            required: true,
            filesize: 2097152 //max size 2mb
          },
          metadata_field_text_99251_value: {
            required: true
          },
          metadata_field_text_101747_value: {
            required: true,
            email: true
          },
          metadata_field_text_101748_value: {
            required: true
          },
          calendar_event_single_0_3163: {
            required: true
          },
          event_description: {
            required: true
          },
          metadata_field_select_99246: {
            required: true
          },
          metadata_field_text_117401_value: {
            required: true
          },
          metadata_field_select_117402: {
            required: true
          }
        },
        messages: {
          calendar_event_single_0_3162: "Please enter event name",
          "start-date": "Please enter start date of event",
          "end-date": "Please enter a valid end date of event",
          "start-hours": "Please enter start time of event",
          "end-hours": {
            timeRequired: "Please enter end time of event",
            startEndTime:
              "Event end time cannot be earlier than event start time"
          },
          metadata_field_text_99250_value: "Please enter location of event",
          image: {
            required: "Please select image for the event",
            filesize: "File size must be less than 2 MB."
          },
          metadata_field_text_99251_value: "Please enter cost of event",
          metadata_field_text_101747_value: {
            required: "Please enter your email address",
            email: "Please enter a valid email address"
          },
          metadata_field_text_101748_value: "Please enter phone number",
          calendar_event_single_0_3163: "Please enter event description",
          event_description: "Please enter event description",
          metadata_field_select_99246: "Please enter event category"
        },
        errorPlacement: function(error, element) {
          var $errorLabel = $(element)
            .parents(".form__field")
            .last()
            .find(".form__error");
          $errorLabel.html(error.text());
        },
        highlight: function(element) {
          $(element)
            .parents(".form__field")
            .last()
            .find(".form__error")
            .show();
        },
        unhighlight: function(element) {
          $(element)
            .parents(".form__field")
            .last()
            .find(".form__error")
            .hide();
        },
        submitHandler: function(form, event) {
          event.preventDefault();

          if ($(".js-form-technical-error").length) {
            $(".js-form-technical-error").hide();
          }

          if ($(".js-form-loader").length) {
            $(".js-form-loader").fadeIn(300);
          }

          $("#page_asset_builder_100855 .js-submit").prop("disabled", true);

          fillStartEndDate();
          if (debugFlag) {
            console.log("Starting image upload script");
          }

          uploadImage(form);
        }
      });

      window.onload = function() {
        $("#metadata_field_select_117402 option")
          .first()
          .text("Please select...");
      };
    }
  });

  if ($(".js-form-loader").length) {
    $(".js-form-loader").click(function() {
      return false;
    });
  }
})(jQuery);
